import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] relative rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-[25px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TotalStudents = _resolveComponent("TotalStudents")!
  const _component_TotalTeachers = _resolveComponent("TotalTeachers")!
  const _component_AttendanceToday = _resolveComponent("AttendanceToday")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TotalStudents),
        _createVNode(_component_TotalTeachers),
        _createVNode(_component_AttendanceToday)
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-[1px] absolute top-0 bottom-0 bg-gray-100 dark:bg-[#172036] left-[33.3333333333%] -translate-x-[33.3333333333%] hidden sm:block" }, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-[1px] absolute top-0 bottom-0 bg-gray-100 dark:bg-[#172036] right-[33.3333333333%] translate-x-[33.3333333333%] hidden sm:block" }, null, -1))
  ]))
}